import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressComponent implements OnChanges {

  @Input() total: number = 0;
  @Input() units: number = 0;
  percentual: number = 0;

  ngOnChanges(changes: SimpleChanges): void {
    this.percentual = Math.round(this.units / this.total * 100);
  }

}
